import { Country, Company, countries, countryDotOffsets } from "./countries";
import { createElementAddClass } from "./util/utils";

const interactiveMap = () => {
	const map = document.getElementById("interactive-map") as HTMLObjectElement;

	map.onload = () => {
		const svgDoc = map.contentDocument;
		if (!svgDoc) return;

		const svg = svgDoc.querySelector("svg");
		if (!svg) return;

		const labelGroup = document.createElementNS(
			"http://www.w3.org/2000/svg",
			"g"
		);
		labelGroup.setAttribute("id", "country-labels");
		svg.appendChild(labelGroup);

		for (const country of countries) {
			const countryElement = svgDoc.getElementById(country.name);

			if (countryElement) {
				createCountryLabel(country.name, countryElement, labelGroup);
				setEventListeners(country, countryElement, svgDoc);
			}
		}
	};
};

const createCountryLabel = (
	country: string,
	countryElement: Element,
	labelGroup: SVGElement
) => {
	const bbox = (countryElement as SVGGraphicsElement).getBBox();

	const offset = countryDotOffsets[country] || { x: 0, y: 0 };

	const cx = bbox.x + bbox.width / 2 + offset.x;
	const cy = bbox.y + bbox.height / 2 + offset.y;

	const label = document.createElementNS("http://www.w3.org/2000/svg", "text");
	label.setAttribute("x", (bbox.x + bbox.width / 2).toString());
	label.setAttribute("y", (bbox.y + bbox.height / 2).toString());
	label.setAttribute("text-anchor", "middle");
	label.setAttribute("dominant-baseline", "middle");
	label.setAttribute("fill", "white");
	label.setAttribute("font-size", "10");
	label.setAttribute("data-country", country);
	label.classList.add("country-label");
	label.textContent = country;

	const circle = document.createElementNS(
		"http://www.w3.org/2000/svg",
		"circle"
	);
	circle.setAttribute("cx", cx.toString());
	circle.setAttribute("cy", cy.toString());
	circle.setAttribute("r", "2"); // 8px diameter
	circle.classList.add("pulse-dot", `dot-${country.toLowerCase()}`);

	labelGroup.appendChild(circle);
	labelGroup.appendChild(label);
};

const setEventListeners = (country: Country, countryElement: Element, svgDoc: Document) => {
	let countryDetailsContainer: HTMLDivElement;
	country.location === "East"
		? (countryDetailsContainer = document.getElementById(
			"country-details--east"
		) as HTMLDivElement)
		: (countryDetailsContainer = document.getElementById(
			"country-details--west"
		) as HTMLDivElement);


	const dot = svgDoc.querySelector(`.dot-${country.name.toLowerCase()}`);

	countryElement.addEventListener("click", () => {
		removeCompanyDetails(svgDoc);

		for (const company of country.companies) {
			const companyDetails = createCompanyDetails(company);
			countryDetailsContainer.appendChild(companyDetails);
		}

		if (dot) dot.classList.add("pulsing");
	});

	document.addEventListener("click", (e) => {
		const target = e.target as Node;
		if (!countryDetailsContainer.contains(target) && !countryElement.contains(target)) {
			const companyDetailsElements =
				countryDetailsContainer.querySelectorAll(".company-details");

			for (const companyDetailsElement of companyDetailsElements) {
				companyDetailsElement.remove();
			}
			if (dot) dot.classList.remove("pulsing");
		}
	});
};

const removeCompanyDetails = (svgDoc: Document) => {
	const companyDetails = document.querySelectorAll(".company-details");
	const dots = svgDoc.querySelectorAll('.pulse-dot')

	for (const companyDetailsElement of companyDetails) {
		companyDetailsElement.remove();
	}

	for (const dot of dots) {
		dot.classList.remove("pulsing");
	}
}

const createCompanyDetails = (company: Company) => {
	const companyDetailsContainer = createElementAddClass(
		"div",
		"company-details"
	);
	const logoContainter = createElementAddClass("div", "company-logo-container");
	const companyImage = createElementAddClass(
		"img",
		"company-image"
	) as HTMLImageElement;
	const companyLogo = createElementAddClass(
		"img",
		"company-logo"
	) as HTMLImageElement;

	companyImage.src = company.imageSrc;
	companyLogo.src = company.logoSrc;
	companyLogo.alt = `${company.name} logo`;

	logoContainter.appendChild(companyLogo);
	companyDetailsContainer.appendChild(companyImage);
	companyDetailsContainer.appendChild(logoContainter);

	companyDetailsContainer.addEventListener('click', () => {
		if (company.linkSrc.length > 0) {
			window.open(company.linkSrc, '_blank').focus()
		}
	})

	return companyDetailsContainer;
};

export default interactiveMap;
